module.exports = __webpack_public_path__ + "static/img/title.afddf05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardTW/img/title.png
// module id = eKpl
// module chunks = 1